import { render, staticRenderFns } from "./courseShopping.vue?vue&type=template&id=08655d02"
import script from "./courseShopping.vue?vue&type=script&lang=js"
export * from "./courseShopping.vue?vue&type=script&lang=js"
import style0 from "./courseShopping.vue?vue&type=style&index=0&id=08655d02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports